import React from 'react';
import Icon  from 'components/ui/icon';

const IconError = () => {
  return <Icon icon="uncheck-circle" className="error" />;
};

export default IconError;
